###
This factory provides a `clear` function that can be invoked to clear any cached
sensitive data.

Data is cached in two ways in the app: using the HTTP cache, and by storing it
in an object. This factory can accomodate both of these scenarios.

For caching using `$http` and `$resource`, a cache should be added to the CACHES
object, and this value should be used as the value for the `cache` property of
the `$http` or `$resource` configuration.

For caches using objects, the `getSharedObject`, `hasSharedObject`, and
`setSharedObject` functions can be used to associate an arbitray object with a
key. The reference to this object will be removed when the cache is cleared.

###
angular.module("rjmNg.common.api").factory "sharedCaches", [
  "$cacheFactory"
  (
    $cacheFactory
  ) ->

    SHARED_OBJECTS = {}

    clear = () ->
      $cacheFactory.get("$http")?.removeAll()
      SHARED_OBJECTS = {}

    # If the specified object is undefined, and a function is provided as the
    # value of the `invokeeIfUndefined` argument, this function will be called
    # if the specified key doesn't exist—this function should return the value
    # to store.
    getSharedObject = (key, invokeeIfUndefined) ->
      if not SHARED_OBJECTS[key]? and invokeeIfUndefined?
        SHARED_OBJECTS[key] = invokeeIfUndefined(key)

      return SHARED_OBJECTS[key]

    hasSharedObject = (key) ->
      Boolean(SHARED_OBJECTS[key]?)

    setSharedObject = (key, value) ->
      SHARED_OBJECTS[key] = value
      return value

    {
      ARRAY: () -> []
      OBJECT: () -> {}
      clear
      getSharedObject
      hasSharedObject
      setSharedObject
    }

]
